import React from "react";
import tracheostomyImage from "../images/tracheostomy.jpg";
import lionImage from "../images/lions.jpg";


function article_1() {
	return {
		date: "May 25, 2026",
		title: "Supporting Confidence Development in Tracheostomy Care Through VR-Based Procedural Rehearsal",
		description:
			"",
		keywords: [
			"Virtual Reality","Simulation-based Training","Tracheostomy Care","Procedural Rehearsal"," Ecological Validity",
		],
		style: `
				.article-content {
					display: flex;
					flex-direction: column;
					align-items: center;
				}
				.paper-button {
					margin-top: 30px;
					margin-bottom: 30px;
					display: inline-block;
					padding: 6px 20px;
					background: #2563eb;
					color: #fff;
					text-decoration: none;
					font-weight: 400;
					border-radius: 2px;
					transition: all 0.2s ease;
					box-shadow: 0 3px 8px rgba(0, 0, 0, 0.15);
				}

				.paper-button:hover {
					background: #1d4ed8;
					transform: translateY(-2px);
					box-shadow: 0 6px 14px rgba(0, 0, 0, 0.2);
				}

				.paper-button:active {
					transform: translateY(0);
				}
				.randImage {
					width: 300px;
					align-self: center;
				}
				`,
		body: (
			<React.Fragment>
				<div className="article-content">
					<div className="header"><h2>Abstract</h2> </div>
					<div className="paragraph">		
Tracheostomy care represents a specialized but low-frequency and high-risk (LFHR) clinical responsibility within the Department of Otorhinolaryngology (ENT) at Rigshospitalet, where limited exposure may affect nurses’ confidence and preparedness. This project explored how a virtual reality (VR) training experience could be designed to support confidence development and procedural familiarity related to tracheostomy care. Through an exploratory and iterative design process conducted in collaboration with the department, a VR-based training application was developed and evaluated with nurses from the ENTdepartment. The evaluation consisted of think-aloud testing, semi-structured interviews, and observational data, which were subsequently analyzed using reflexive thematic analysis(RTA). The findings suggest that participants perceived the VR application as a meaningful supplementary training tool for on boarding, repetition-based practice, competence development, and procedural rehearsal within LFHR healthcare contexts rather than as a replacement for their existing clinical practices. Participants emphasized the value of hands-on interaction, recognizable workflows, and the ability to rehearse procedures in a safe environment. The findings additionally highlighted the importance of usability, onboarding, and balancing realism with intuitive interaction design within VR-based healthcare training. Overall, the results indicate that meaningful VR-based healthcare training may depend less on complete realism and more on creating believable and usable interactions capable of supporting onboarding, confidence development, and procedural rehearsal within specialized LFHR healthcare contexts.
					</div>
					
					<a
						href="https://drive.google.com/drive/folders/1-cqT_tKes0px4WviT4ShVjG8k1LdwxAu?usp=sharing"
						target="_blank"
						rel="noopener noreferrer"
						className="paper-button"
					>
						View Papers
					</a>

					<img
						src={tracheostomyImage}
  						alt="Tracheostomy"
  						className="randImage"
					/>
					
				</div>
			</React.Fragment>
		),
	};
}

function article_2() {
	return {
		date: "May 25, 2025",
		title: "XR for Residents at Lions Neurocenter",
		description:
			"",
		keywords: [
			"",
		],
		style: `
				.article-content {
					display: flex;
					flex-direction: column;
					align-items: center;
				}
				.paper-button {
					margin-top: 30px;
					margin-bottom: 30px;
					display: inline-block;
					padding: 6px 20px;
					background: #2563eb;
					color: #fff;
					text-decoration: none;
					font-weight: 400;
					border-radius: 2px;
					transition: all 0.2s ease;
					box-shadow: 0 3px 8px rgba(0, 0, 0, 0.15);
				}

				.paper-button:hover {
					background: #1d4ed8;
					transform: translateY(-2px);
					box-shadow: 0 6px 14px rgba(0, 0, 0, 0.2);
				}

				.paper-button:active {
					transform: translateY(0);
				}
				.randImage {
					width: 300px;
					align-self: center;
				}
				`,
		body: (
			<React.Fragment>
				<div className="article-content">
					<div className="header"><h2>Abstract</h2> </div>
					<div className="paragraph">
						This project explores how extended reality (XR) can be co-designed with Lions Neurocenter to support cognitive and physical stimulation for individuals with acquired brain injury who are past the phase of focused rehabilitation. The focus was on developing an accessible XR experience that fits within existing care routines and can be used by non-technical staff, with an additional emphasis on creating a practical guide to support staff in effectively integrating the application into their daily workflows. Using an iterative and exploratory, user-centered design process, we created an XR application emphasizing simple motor interaction and sensory feedback, including interactive music. Three development cycles involved direct input from residents and staff, leading to a solution that was engaging and feasible for implementation. While conclusions remain preliminary due to the small sample size and contextual constraints, findings suggest that immersive, low-complexity interactions hold promise for stimulating engagement and supporting quality of life in long-term care settings.
					</div>
					<a
						href="https://drive.google.com/drive/folders/1-cqT_tKes0px4WviT4ShVjG8k1LdwxAu?usp=sharing"
						target="_blank"
						rel="noopener noreferrer"
						className="paper-button"
					>
						View Papers
					</a>
					
					<img
						src={lionImage}
  						alt="lions"
  						className="randImage"
					/>
				</div>
			</React.Fragment>
		),
	};
}

const myArticles = [article_1, article_2];

export default myArticles;
